import React, { useContext, useState, useMemo, memo, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { getRegionFilters, getCityFilters } from '../BackendAPI';
import { InvestorSearchContext } from '../contexts/InvestorSearchContext';
import { Select, Button, Flex, CloseButton } from './primitives';
import captureError from '../utils/sentry';
import { parseParams } from '../pages/AdvancedSearch';
import LocationFilterModal from './LocationFilterModal';

const InlineLabel = ({ filter, toggle }) => {
  const labelText = filter.label.toLowerCase();
  const isVertical = ['ft', 're', 'mt', 'ci', 'cs'].includes(labelText);

  const labelClasses = useMemo(() => {
    let labelClass = 'cs';
    if (isVertical) {
      labelClass = filter.checked ? labelText : 'empty';
    } else {
      labelClass = filter.checked ? 'ft' : 'empty';
    }
    return labelClass;
  }, [filter?.checked, isVertical, labelText]);

  return (
    <span
      className={`vertical-item ${labelClasses}`}
      key={`tier${filter.label}`}
      onClick={() => toggle(filter.value)}
    >
      {filter.label}
    </span>
  );
};

const FilterItem = ({ filter, toggle }) => {
  return (
    <li key={filter.label} className="form-checkbox-row">
      <div className="form-check form-check-inline">
        <label className="form-check-label">
          <input
            className="form-check-input"
            type="radio"
            name={filter.label}
            checked={filter.checked}
            onChange={() => toggle(filter.label)}
          />
          {filter.label}
          <i className="fa fa-circle-thin unchecked" aria-hidden="true" />
          <i className="fa fa-check-circle checked" aria-hidden="true" />
        </label>
      </div>
    </li>
  );
};

const FilterModal = ({ showModal, setShowModal, filters, toggle, filterLabel }) => {
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      className="tv-showModal tv-company-showModal"
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{filterLabel} Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled list-spaced">
          {filters.map((filter, index) => (
            <FilterItem key={index} filter={filter} toggle={toggle} />
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setShowModal(false)}>Done</Button>
      </Modal.Footer>
    </Modal>
  );
};

const Filter = ({ filterList, filterLabel, filterType, hasModal, resetFilters }) => {
  const [state, dispatch] = useContext(InvestorSearchContext);
  const [showModal, setShowModal] = useState(false);

  const toggle = (value) => dispatch({ filterList, filterType, value });
  const filters = state.siteFilters[filterType][filterList];
  const numChecked = filters.filter((f) => f.checked).length;

  const [locationLabel, setLocationLabel] = useState('-');

  return (
    <div className="company-score vertical-expertise">
      {!hasModal && (
        <div>
          <label>{filterLabel}</label>
          <span className="score">
            {filters.map((filter, index) => (
              <InlineLabel key={index} filter={filter} toggle={toggle} />
            ))}
          </span>
        </div>
      )}
      {hasModal && (
        <div>
          <label>{filterLabel}</label>
          {filterLabel === 'Location' ? (
            <div className="selected" onClick={() => setShowModal(!showModal)}>
              <p>{locationLabel}</p>
            </div>
          ) : (
            <div className="selected" onClick={() => setShowModal(!showModal)}>
              <p>
                {numChecked} {filterLabel} Selected
              </p>
            </div>
          )}
          {filterList === 'location' ? (
            <LocationFilterModal
              showModal={showModal}
              setShowModal={setShowModal}
              filters={filters}
              toggle={toggle}
              filterLabel={filterLabel}
              setLocationLabel={setLocationLabel}
              resetFilters={resetFilters}
            />
          ) : (
            <FilterModal
              showModal={showModal}
              setShowModal={setShowModal}
              filters={filters}
              toggle={toggle}
              filterLabel={filterLabel}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(Filter);
